// extracted by mini-css-extract-plugin
module.exports = {"answerContainer":"FlavorFinderAnswer_answerContainer__uuqrb","imageContainer":"FlavorFinderAnswer_imageContainer__C2nwM"};